
import { ApiProperty } from "@nestjs/swagger";
export class MandalNameRequest {
  @ApiProperty()
  mandalName: string;
}
export class MandalIdRequest {
  @ApiProperty()
  Id: number;
}
export class MandalCodeRequest {
  @ApiProperty()
  mandalCode: string;
  @ApiProperty()
  status: boolean;
}
